import { Button, Divider, Modal } from "antd";
import React from "react";
import BusinessContactInfo from "../BusinessContactInfo";

export default function SalesCount(props) {

    const { data = [], title = "" } = props;
    if (data.length === 0) { return (<></>); }


    const drawDetails = () => {

        return (
            <>
                <Divider dashed style={{ "margin": "15px 0px" }} />  
                {data.map(item => {

                    const { name = "", contact_id = "" } = item;

                    return (<div><BusinessContactInfo logo={true} id={contact_id} /> <Divider  style={{ "margin": "15px 0px" }} />  </div>)
                })}
            </>
        )

    }

    return (
        <>
            <Button onClick={() => Modal.info({ maskClosable: true, width : 600, okText: "Close", okButtonProps: { type: "default" }, icon: null, title: <>Sales & Marketing companies for: <em>{title}</em></>, content: <>{drawDetails()}</> })} size="small" className="mini-btn" ><small>Sales &amp; Marketing ({data.length}) </small></Button>
        </>
    );

}